export interface TaxIncentiveAssumptions {
  residentCrewPercent: number;
  applyPromotionalUplift: boolean;
  applyLocationUplift: boolean;
  usesFinancing: boolean;
  bridgeLoanRatePercent: number;
  financingMonths: number;
}

export const DEFAULT_TAX_INCENTIVE_ASSUMPTIONS: TaxIncentiveAssumptions = {
  residentCrewPercent: 70,
  applyPromotionalUplift: true,
  applyLocationUplift: false,
  usesFinancing: false,
  bridgeLoanRatePercent: 8,
  financingMonths: 12,
};

export interface TaxFrictionLine {
  label: string;
  amount: number;
}

export interface TaxEffectiveRateSummary {
  grossBudget: number;
  qualifiedSpend: number;
  headlineCredit: number;
  totalFriction: number;
  effectiveNetCredit: number;
  netCost: number;
  headlineRatePercent: number;
  effectiveRatePercent: number;
  locationNames: string[];
  primaryJurisdiction: string;
  frictionBreakdown: TaxFrictionLine[];
  meetsMinimumSpend: boolean;
  minimumSpend?: number;
}

export interface TaxNettingSummary extends TaxEffectiveRateSummary {
  eligibleSpend: number;
  estimatedRebate: number;
  rebatePercent: number;
}

export interface QualifiedSpendBreakdown {
  atlSpend: number;
  btlSpend: number;
  qualifiedAtlSpend: number;
  qualifiedBtlSpend: number;
  qualifiedSpend: number;
}

export interface JurisdictionCompareAvailability {
  jurisdictionName: string;
  isAvailable: boolean;
  unavailableReason?: string;
}

export interface JurisdictionEffectiveRateResult extends TaxEffectiveRateSummary {
  jurisdictionName: string;
  rankScore: number;
}

export interface JurisdictionSpendAllocation {
  jurisdictionName: string;
  sceneCount: number;
  shootDayShare: number;
  allocatedSpend: number;
  effectiveRate: TaxEffectiveRateSummary;
}

export interface MultiJurisdictionEffectiveRateSummary {
  grossBudget: number;
  allocations: JurisdictionSpendAllocation[];
  blendedHeadlineCredit: number;
  blendedEffectiveNetCredit: number;
  blendedNetCost: number;
  blendedEffectiveRatePercent: number;
}
